import React from "react";
import { useStoreRehydrated } from "easy-peasy";
import Navigation from "./pages";

function App() {
  const isRehydrated = useStoreRehydrated();
  return <div>{isRehydrated ? <Navigation /> : <div>Loading...</div>}</div>;
}

export default App;
